<template>
  <el-dialog title="收货地址" :visible.sync="dialogTableVisible" :fullscreen='true' @close='close'>
    <div slot="title" class="title"><span>风险评价</span></div>
    <div class="body">
      <p class="p1">风险等级 <strong>R</strong></p>
      <div class="table">
        <div class="tableBody">
          <el-table
            :data="tableData"
            :span-method="objectSpanMethod"
            border :header-cell-style="{background: 'rgb(250,250,250)',color: 'black',fontWeight: 400}"
            :cell-style="cellstyle"
            style="width: 100%;">
            <el-table-column
              label="区域风险等级判定"
              prop="id"
              min-width="35%">
            </el-table-column>
            <el-table-column label="区域控制风险">
              <el-table-column
                prop="name"
                min-width="12%"
              >
              </el-table-column>
              <el-table-column
                label="D"
                prop="amount1"
                min-width="12%"
              >
              </el-table-column>
              <el-table-column
                label="C"
                prop="amount2"
                min-width="12%"
              >
              </el-table-column>
              <el-table-column
                label="B"
                prop="amount3"
                min-width="12%"
              >
              </el-table-column>
              <el-table-column
                label="A"
                prop="amount4"
                min-width="12%"
              >
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <p class="p2">区域风险等级用R表示，当：</p>
      <ul>
        <li>R=[IVD]，区域风险等级判定为蓝色低风险；</li>
        <li>R=[IIID, IIIC, IVC]，区域风险等级判定为黄色一般风险；</li>
        <li>R=[IID, IIC, IIIB, IVB]，区域风险等级判定为橙色较大风险；</li>
        <li>R=[ID, IC, IB, IIB, IA , IIA , IIIA, IVA]，区域风险等级判定为红色重大风险。</li>
      </ul>
      <p class="p3">区域安全风险级别校正：</p>
      <span>校正等级：</span>
      <el-input-number :disabled="true" v-model="obj.calibrationLevel" @change="handleChange" size="small" style="width: 150px"
       :min="0" :max="maxNum" label="描述文字" controls-position="right">
      </el-input-number>
      <p>在区域风险分级评估的基础上，对存在以下情形的，进行区域风险等级校正（最高为红色重大风险等级）。</p>
      <ul>
        <el-checkbox-group v-model="checkList" @change="checkChange">
        <li><el-checkbox :label="1 + '-check1'">任一区域发生没有人员伤亡的火灾、爆炸、有毒气体泄漏事故的，自事故发生之日起，该区域提高1个风险等级。</el-checkbox></li>
        <li><el-checkbox :label="2 + '-check2'">任一区域发生一般生产安全事故的，自事故发生之日起，该区域提高2个风险等级。</el-checkbox></li>
        <li><el-checkbox :label="3 + '-check3'">任一区域发生较大及以上生产安全事故的，自事故发生之日起，直接认定该区域为红色重大风险等级。</el-checkbox></li>
        <li><el-checkbox :label="2 + '-check4'">任一区域存在列为省级以上隐患挂牌督办且未完成整改的，该区域提高2个风险等级。</el-checkbox></li>
        <li><el-checkbox :label="1 + '-check5'">任一区域存在市级隐患挂牌督办且未完成整改的，该区域提高1个风险等级。</el-checkbox></li>
        <li><el-checkbox :label="1 + '-check6'">构成危险化学品一级、二级重大危险源的场所和设施，该区域提高1个风险等级。</el-checkbox></li>
        <li><el-checkbox :label="1 + '-check7'">涉及重点监管化工工艺的装置，该区域提高1个风险等级。</el-checkbox></li>
        <li><el-checkbox :label="1 + '-check8'">涉及爆炸品的场所和设施，该区域提高1个风险等级。</el-checkbox></li>
        <li><el-checkbox :label="1 + '-check9'">化工装置、危险化学品设施“带病”运行，如超期运行、设备存在缺陷等，该区域提高1个风险等级。</el-checkbox></li>
        </el-checkbox-group>
      </ul>
      <p class="p4">最终结果: 风险等级<strong>R + 校正级别</strong> = {{ dangerLevel }} + {{ obj.calibrationLevel }}
        <span v-if="result === '重大风险'" class="result word1">重大风险</span>
        <span v-if="result === '较大风险'" class="result word2">较大风险</span>
        <span v-if="result === '一般风险'" class="result word3">一般风险</span>
        <span v-if="result === '低风险'" class="result word4">低风险</span>
      </p>
      <div style="margin-top: 15px">
        复评时间：
        <el-date-picker
          v-model="reRevaluationTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
          size="small"
        />
      </div>
    </div>
    <div slot="footer">
      <el-button size="small" class="footBtn"  @click="close">取消</el-button>
      <el-button size="small" type="primary" class="footBtn" @click="submit">保存结果</el-button>
    </div>
</el-dialog>
</template>

<script>
import { saveResult } from '@/api/processManager'
export default {
  name: 'riskEvaluation',
  props: ['status','sendMessage'],
  data() {
    return {
      maxNum: 0,
      checkList: [],
      tableData: [{
        id: '区域固有风险',
        name: 'IV',
        amount1: 'IVD',
        amount2: 'IVC',
        amount3: 'IVB',
        amount4: 'IVA'
      }, {
        id: '12987123',
        name: 'III',
        amount1: 'IIID',
        amount2: 'IIIC',
        amount3: 'IIIB',
        amount4: 'IIIA'
      }, {
        id: '12987124',
        name: 'II',
        amount1: 'IID',
        amount2: 'IIC',
        amount3: 'IIB',
        amount4: 'IIA'
      }, {
        id: '12987125',
        name: 'I',
        amount1: 'ID',
        amount2: 'IC',
        amount3: 'IB',
        amount4: 'IA'
      }],
      // 保存区域id和控制风险等级的对象
      obj: {
        id: '',
      },
      dangerLevel: '',
      result: '',
      newMap: null,
      reRevaluationTime: ''
    }
  },
  created() {
    let map = new Map([
      ['33', '低风险'], ['32', '一般风险'], ['31', '较大风险'], ['30', '重大风险'],
      ['23', '一般风险'], ['22', '一般风险'], ['21', '较大风险'], ['20', '重大风险'],
      ['13', '较大风险'], ['12', '较大风险'], ['11', '重大风险'], ['10', '重大风险'],
      ['03', '重大风险'], ['02', '重大风险'], ['01', '重大风险'], ['00', '重大风险'],
    ]);
    this.newMap = map;
  },
  watch: {
    status(val){
      if(val) {
        this.Calculator(this.sendMessage.inherentRiskLevel,this.sendMessage.controlRiskLevel)
        this.$set(this.obj,'calibrationLevel',this.sendMessage.calibrationLevel)
        this.$set(this.obj,'id',this.sendMessage.id)
        this.result = this.newMap.get(this.sendMessage.inherentRiskLevel + '' + this.sendMessage.controlRiskLevel)
        this.$set(this.obj,'romanRiskLevel',this.sendMessage.romanRiskLevel)
        this.$set(this.obj, 'inherentRiskLevel', this.sendMessage.inherentRiskLevel)
        this.maxNum = this.sendMessage.controlRiskLevel
        if(this.sendMessage.correctionItem) {
          this.checkList = this.sendMessage.correctionItem.split(',')
        }
      }
    },
    // sendMessage(val){
    //   this.Calculator(val.inherentRiskLevel,this.sendMessage.controlRiskLevel)
    //   this.$set(this.obj,'calibrationLevel',val.calibrationLevel)
    //   this.$set(this.obj,'id',val.id)
    //   this.result = this.newMap.get(this.sendMessage.inherentRiskLevel + '' + this.sendMessage.controlRiskLevel)
    //   this.$set(this.obj,'romanRiskLevel',val.romanRiskLevel)
    //   this.$set(this.obj, 'inherentRiskLevel', this.sendMessage.inherentRiskLevel)
    //   this.maxNum = val.controlRiskLevel
    // },
  },
  computed: {
    dialogTableVisible: {
      get() {
        return this.status
      },
      set() {
        return this.status
      }
    }
  },
  methods: {
    close() {
      this.$emit('backMsg', false)
      this.checkList = []
      this.reRevaluationTime = ''
    },
    checkChange(val) {
      let num = 0
      for(let i in val) {
        num += Number(val[i].split('-')[0])
      }
      if(this.maxNum > num) {
        this.$set(this.obj, 'calibrationLevel', num);
      } else {
        this.$set(this.obj, 'calibrationLevel', this.maxNum);
        num = this.maxNum
      }
      // console.log(this.obj.calibrationLevel)
      this.result = this.newMap.get(this.sendMessage.inherentRiskLevel + '' +  (this.sendMessage.controlRiskLevel - num) )
    },
    // 计数器的事件
    handleChange(value) {
      
    },
    // 表格的合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
          if (rowIndex % 4 === 0) {
            return {
              rowspan: 4,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },
      // 单元格背景色
      cellstyle({row, column, rowIndex, columnIndex}) {
        if(columnIndex === 2) {
          if(rowIndex === 0) {
            return 'background: rgb(0,176,240); color: black;'
          }
          if(rowIndex == 1) {
            return 'background: rgb(255,255,0); color: black'
          }
          if(rowIndex === 2 ) {
            return 'background: rgb(227,108,10); color: black'
          }
          if(rowIndex === 3) {
            return "background: rgb(255,0,0); color: black"
          }
        }
        if(columnIndex === 3) {
          if(rowIndex === 0 || rowIndex === 1) {
            return 'background: rgb(255,255,0); color: black'
          }
          if(rowIndex === 2 ) {
            return 'background: rgb(227,108,10); color: black'
          }
          if(rowIndex === 3) {
            return "background: rgb(255,0,0); color: black"
          }
        }
        if(columnIndex === 4) {
          if(rowIndex === 0 || rowIndex === 1) {
            return 'background: rgb(227,108,10); color: black'
          }
          if(rowIndex === 2 || rowIndex ===3 ){
            return "background: rgb(255,0,0); color: black"
          }
        }
        if(columnIndex === 5) {
          return "background: rgb(255,0,0); color: black"
        }
      },
    // 计算区域风险等级的函数
    Calculator(val1,val2) {
      let inherentRiskLevel = ""
      let controlRiskLevel = ""
      switch(val1){
        case 0:
          inherentRiskLevel = "I"
          break
        case 1:
          inherentRiskLevel = "II"
          break
        case 2:
          inherentRiskLevel = "III"
          break
        case 3:
          inherentRiskLevel = "IV"
          break
      };
      switch(val2){
        case 0:
          controlRiskLevel = "A"
          break
        case 1:
          controlRiskLevel = "B"
          break
        case 2:
          controlRiskLevel = "C"
          break
        case 3:
          controlRiskLevel = "D"
          break
      }
      this.dangerLevel = inherentRiskLevel + controlRiskLevel
    },
    // 保存结果
    submit() {
      let result = null
      if(this.result === "重大风险"){
        result = 0
      }else if (this.result === "较大风险"){
        result = 1
      } else if (this.result === '一般风险'){
        result = 2
      }else {
        result = 3
      }
      this.$set(this.obj, 'result', result)
      saveResult({ id: this.obj.id, calibrationLevel: this.obj.calibrationLevel, correctionItem: this.checkList, reRevaluationTime: this.reRevaluationTime }).then((res) => {
        // console.log(res)
        this.$emit('backMsg', false, 'save')
      })
    }
  }
}
</script>

<style scoped>
  .title span {
    line-height: 55px;
    font-size: 20px;
  }
  /deep/ .el-dialog__header{
    background-color: white;
    width: 100vw;
    height: 55px;
    border-radius: 4px 4px 0 0;
    border: 1px solid #e8e8e8;
    padding: 0 30px 0 24px;
    position: fixed;
    top: 0;
    z-index: 999;
    padding: 0 0 0 25px;
  }
  /deep/ .el-icon-close {
    font-size: 25px;
    width: 16px
  }
  .body {
    margin-top: 55px;
    width: 100%;
    /* height: 2000px; */
    margin-bottom: 70px;
  }
  .body .p1 {
    font-size: 16px;
    font-weight: 500
  }
  .body .p2 {
    margin-top: 15px;
  }
  .p3 {
    color: black;
    margin-top: 15px;
    margin-bottom: 5px;
  }
  .p4 {
    font-size: 16px;
    margin-top: 25px;
  }
  .body ul {
    margin-left: 40px;
  }
  .table {
    width: 100%;
    height: 325px;
    border: 1px solid #e8e8e8;
    margin-top: 10px;
  }
  .el-table /deep/ .cell {
    text-align: center;
  }
  .tableBody /deep/ .el-table__body {
    height: 225px;
  }
  /deep/ .el-dialog__footer {
    background-color: white;
    width: 100vw;
    height: 70px;
    border-radius: 0 0 4px 4px;
    border: 1px solid #e8e8e8;
    padding: 0 30px 0 24px;
    position: fixed;
    bottom: 0;
    /* padding: 15px 0 20px 0; */
  }
  .footBtn {
    margin-top: 15px;
    margin-bottom: 35px;
  }
  .result {
    margin-left: 10px;
    display: inline-block;
    padding: 1px 6px;
    color: black;
    border-radius: 2px;
    font-size: 13px
  }
  .word1 {
    background-color: red; 
  }
  .word2 {
    background-color: rgb(227,108,10);
  }
  .word3 {
    background-color: rgb(255,255,0)
  }
  .word4 {
    background-color: rgb(0,176,240)
  }
</style>